var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodoistLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "500 500 1450 1450",
    height: 2458,
    width: 2458
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "todoist-logo_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1844v1844H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#todoist-logo_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 2458.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1304.5 1434h-768c-70.4 0-128-57.6-128-128V538c0-70.4 57.6-128 128-128h768c70.4 0 128 57.6 128 128v768c0 70.4-57.6 128-128 128",
    fill: "#e44332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.257 954.226c18.088 10.425 405.501 233.359 414.391 238.495 8.872 5.12 9.317 20.833-.609 26.498-9.937 5.665-28.799 16.381-35.819 20.488-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.854-336.042-193.231-347.109-199.521-13.246-7.53-29.638-7.627-42.84.013-10.423 6.034-174.857 101.584-174.857 101.584v-86.356c42.564-24.786 148.39-86.421 174.038-100.9 15.307-8.643 29.96-8.43 44.72.078",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.257 781.688c18.088 10.425 405.501 233.359 414.391 238.495 8.872 5.121 9.317 20.834-.609 26.499-9.937 5.665-28.799 16.381-35.819 20.488-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.855-336.042-193.232-347.109-199.522-13.246-7.529-29.638-7.627-42.84.013C572.934 873.316 408.5 968.866 408.5 968.866V882.51c42.564-24.786 148.39-86.421 174.038-100.9 15.307-8.643 29.96-8.429 44.72.078",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.257 609.15c18.088 10.425 405.501 233.36 414.391 238.495 8.872 5.121 9.317 20.834-.609 26.5-9.937 5.664-28.799 16.38-35.819 20.487-7.144 4.168-19.996 6.486-31.914-.379-4.948-2.856-336.042-193.232-347.109-199.522-13.246-7.529-29.638-7.627-42.84.013C572.934 700.778 408.5 796.328 408.5 796.328v-86.356c42.564-24.786 148.39-86.42 174.038-100.9 15.307-8.643 29.96-8.429 44.72.078",
    fill: "#fff"
  }))));
}
export default SvgTodoistLogo;